(function () {
    "use strict";

    angular.module("sempraWebapp").factory("savingsActions", savingsActionsFactory);

    /** @ngInject */
    function savingsActionsFactory(api) {
        return {
            getSavingsUsers: getSavingsUsers,
            deactivateSavingsAccount: deactivateSavingsAccount,
            createSavingsAccount: createSavingsAccount,
            getSavingsAccount: getSavingsAccount,
            editSavingsAccount: editSavingsAccount
            // getSavingsReports: getSavingsReports -- COMMENTED OUT
        };

        function getSavingsUsers(page, pageSize, orderBy, order, search) {
            return api.getSavingsUsers(page, pageSize, orderBy, order, search);
        }

        function deactivateSavingsAccount(accountId) {
            return api.deactivateSavingsAccount(accountId);
        }

        function createSavingsAccount(savingsData) {
            return api.createSavingsAccount(savingsData);
        }

        function getSavingsAccount(accountId) {
            return api.getSavingsAccount(accountId);
        }

        function editSavingsAccount(accountId, savingsData) {
            return api.editSavingsAccount(accountId, savingsData);
        }
        // COMMENTED OUT
        // function getSavingsReports(dateFrom, dateTo, timeFrame) {
        //     return api.getSavingsReports(dateFrom, dateTo, timeFrame);
        // }
    }
})();
